/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as BemVindoRouteImport } from './routes/bem-vindo'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProvasIdRouteImport } from './routes/provas.$id'
import { Route as OnboardingTemaRouteImport } from './routes/onboarding/tema'
import { Route as OnboardingHumorRouteImport } from './routes/onboarding/humor'
import { Route as OnboardingAvatarRouteImport } from './routes/onboarding/avatar'
import { Route as OnboardingApelidoRouteImport } from './routes/onboarding/apelido'
import { Route as AvaliacaoIdRouteImport } from './routes/avaliacao.$id'
import { Route as AppSimuladorSisuRouteImport } from './routes/_app/simulador-sisu'
import { Route as AppPainelRouteImport } from './routes/_app/painel'
import { Route as AppPainelIndexRouteImport } from './routes/_app/painel/index'
import { Route as AppPainelSimuladorSisuRouteImport } from './routes/_app/painel/simulador-sisu'
import { Route as AppPainelMinhasProvasRouteImport } from './routes/_app/painel/minhas-provas'
import { Route as AppPainelMateriaisDeEstudoRouteImport } from './routes/_app/painel/materiais-de-estudo'
import { Route as AppPainelListasDeExercicioRouteImport } from './routes/_app/painel/listas-de-exercicio'
import { Route as AppPainelConfiguracoesRouteImport } from './routes/_app/painel/configuracoes'
import { Route as AppPainelMinhasProvasIndexRouteImport } from './routes/_app/painel/minhas-provas.index'
import { Route as AppPainelMateriaisDeEstudoIndexRouteImport } from './routes/_app/painel/materiais-de-estudo.index'
import { Route as AppPainelMinhasProvasIdRouteImport } from './routes/_app/painel/minhas-provas.$id'
import { Route as AppPainelMateriaisDeEstudoIdRouteImport } from './routes/_app/painel/materiais-de-estudo.$id'

const BemVindoRoute = BemVindoRouteImport.update({
  id: '/bem-vindo',
  path: '/bem-vindo',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProvasIdRoute = ProvasIdRouteImport.update({
  id: '/provas/$id',
  path: '/provas/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingTemaRoute = OnboardingTemaRouteImport.update({
  id: '/onboarding/tema',
  path: '/onboarding/tema',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingHumorRoute = OnboardingHumorRouteImport.update({
  id: '/onboarding/humor',
  path: '/onboarding/humor',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingAvatarRoute = OnboardingAvatarRouteImport.update({
  id: '/onboarding/avatar',
  path: '/onboarding/avatar',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingApelidoRoute = OnboardingApelidoRouteImport.update({
  id: '/onboarding/apelido',
  path: '/onboarding/apelido',
  getParentRoute: () => rootRouteImport,
} as any)
const AvaliacaoIdRoute = AvaliacaoIdRouteImport.update({
  id: '/avaliacao/$id',
  path: '/avaliacao/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSimuladorSisuRoute = AppSimuladorSisuRouteImport.update({
  id: '/simulador-sisu',
  path: '/simulador-sisu',
  getParentRoute: () => AppRoute,
} as any)
const AppPainelRoute = AppPainelRouteImport.update({
  id: '/painel',
  path: '/painel',
  getParentRoute: () => AppRoute,
} as any)
const AppPainelIndexRoute = AppPainelIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppPainelRoute,
} as any)
const AppPainelSimuladorSisuRoute = AppPainelSimuladorSisuRouteImport.update({
  id: '/simulador-sisu',
  path: '/simulador-sisu',
  getParentRoute: () => AppPainelRoute,
} as any)
const AppPainelMinhasProvasRoute = AppPainelMinhasProvasRouteImport.update({
  id: '/minhas-provas',
  path: '/minhas-provas',
  getParentRoute: () => AppPainelRoute,
} as any)
const AppPainelMateriaisDeEstudoRoute =
  AppPainelMateriaisDeEstudoRouteImport.update({
    id: '/materiais-de-estudo',
    path: '/materiais-de-estudo',
    getParentRoute: () => AppPainelRoute,
  } as any)
const AppPainelListasDeExercicioRoute =
  AppPainelListasDeExercicioRouteImport.update({
    id: '/listas-de-exercicio',
    path: '/listas-de-exercicio',
    getParentRoute: () => AppPainelRoute,
  } as any)
const AppPainelConfiguracoesRoute = AppPainelConfiguracoesRouteImport.update({
  id: '/configuracoes',
  path: '/configuracoes',
  getParentRoute: () => AppPainelRoute,
} as any)
const AppPainelMinhasProvasIndexRoute =
  AppPainelMinhasProvasIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppPainelMinhasProvasRoute,
  } as any)
const AppPainelMateriaisDeEstudoIndexRoute =
  AppPainelMateriaisDeEstudoIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppPainelMateriaisDeEstudoRoute,
  } as any)
const AppPainelMinhasProvasIdRoute = AppPainelMinhasProvasIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppPainelMinhasProvasRoute,
} as any)
const AppPainelMateriaisDeEstudoIdRoute =
  AppPainelMateriaisDeEstudoIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AppPainelMateriaisDeEstudoRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/bem-vindo': typeof BemVindoRoute
  '/painel': typeof AppPainelRouteWithChildren
  '/simulador-sisu': typeof AppSimuladorSisuRoute
  '/avaliacao/$id': typeof AvaliacaoIdRoute
  '/onboarding/apelido': typeof OnboardingApelidoRoute
  '/onboarding/avatar': typeof OnboardingAvatarRoute
  '/onboarding/humor': typeof OnboardingHumorRoute
  '/onboarding/tema': typeof OnboardingTemaRoute
  '/provas/$id': typeof ProvasIdRoute
  '/painel/configuracoes': typeof AppPainelConfiguracoesRoute
  '/painel/listas-de-exercicio': typeof AppPainelListasDeExercicioRoute
  '/painel/materiais-de-estudo': typeof AppPainelMateriaisDeEstudoRouteWithChildren
  '/painel/minhas-provas': typeof AppPainelMinhasProvasRouteWithChildren
  '/painel/simulador-sisu': typeof AppPainelSimuladorSisuRoute
  '/painel/': typeof AppPainelIndexRoute
  '/painel/materiais-de-estudo/$id': typeof AppPainelMateriaisDeEstudoIdRoute
  '/painel/minhas-provas/$id': typeof AppPainelMinhasProvasIdRoute
  '/painel/materiais-de-estudo/': typeof AppPainelMateriaisDeEstudoIndexRoute
  '/painel/minhas-provas/': typeof AppPainelMinhasProvasIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/bem-vindo': typeof BemVindoRoute
  '/simulador-sisu': typeof AppSimuladorSisuRoute
  '/avaliacao/$id': typeof AvaliacaoIdRoute
  '/onboarding/apelido': typeof OnboardingApelidoRoute
  '/onboarding/avatar': typeof OnboardingAvatarRoute
  '/onboarding/humor': typeof OnboardingHumorRoute
  '/onboarding/tema': typeof OnboardingTemaRoute
  '/provas/$id': typeof ProvasIdRoute
  '/painel/configuracoes': typeof AppPainelConfiguracoesRoute
  '/painel/listas-de-exercicio': typeof AppPainelListasDeExercicioRoute
  '/painel/simulador-sisu': typeof AppPainelSimuladorSisuRoute
  '/painel': typeof AppPainelIndexRoute
  '/painel/materiais-de-estudo/$id': typeof AppPainelMateriaisDeEstudoIdRoute
  '/painel/minhas-provas/$id': typeof AppPainelMinhasProvasIdRoute
  '/painel/materiais-de-estudo': typeof AppPainelMateriaisDeEstudoIndexRoute
  '/painel/minhas-provas': typeof AppPainelMinhasProvasIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/bem-vindo': typeof BemVindoRoute
  '/_app/painel': typeof AppPainelRouteWithChildren
  '/_app/simulador-sisu': typeof AppSimuladorSisuRoute
  '/avaliacao/$id': typeof AvaliacaoIdRoute
  '/onboarding/apelido': typeof OnboardingApelidoRoute
  '/onboarding/avatar': typeof OnboardingAvatarRoute
  '/onboarding/humor': typeof OnboardingHumorRoute
  '/onboarding/tema': typeof OnboardingTemaRoute
  '/provas/$id': typeof ProvasIdRoute
  '/_app/painel/configuracoes': typeof AppPainelConfiguracoesRoute
  '/_app/painel/listas-de-exercicio': typeof AppPainelListasDeExercicioRoute
  '/_app/painel/materiais-de-estudo': typeof AppPainelMateriaisDeEstudoRouteWithChildren
  '/_app/painel/minhas-provas': typeof AppPainelMinhasProvasRouteWithChildren
  '/_app/painel/simulador-sisu': typeof AppPainelSimuladorSisuRoute
  '/_app/painel/': typeof AppPainelIndexRoute
  '/_app/painel/materiais-de-estudo/$id': typeof AppPainelMateriaisDeEstudoIdRoute
  '/_app/painel/minhas-provas/$id': typeof AppPainelMinhasProvasIdRoute
  '/_app/painel/materiais-de-estudo/': typeof AppPainelMateriaisDeEstudoIndexRoute
  '/_app/painel/minhas-provas/': typeof AppPainelMinhasProvasIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/bem-vindo'
    | '/painel'
    | '/simulador-sisu'
    | '/avaliacao/$id'
    | '/onboarding/apelido'
    | '/onboarding/avatar'
    | '/onboarding/humor'
    | '/onboarding/tema'
    | '/provas/$id'
    | '/painel/configuracoes'
    | '/painel/listas-de-exercicio'
    | '/painel/materiais-de-estudo'
    | '/painel/minhas-provas'
    | '/painel/simulador-sisu'
    | '/painel/'
    | '/painel/materiais-de-estudo/$id'
    | '/painel/minhas-provas/$id'
    | '/painel/materiais-de-estudo/'
    | '/painel/minhas-provas/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/bem-vindo'
    | '/simulador-sisu'
    | '/avaliacao/$id'
    | '/onboarding/apelido'
    | '/onboarding/avatar'
    | '/onboarding/humor'
    | '/onboarding/tema'
    | '/provas/$id'
    | '/painel/configuracoes'
    | '/painel/listas-de-exercicio'
    | '/painel/simulador-sisu'
    | '/painel'
    | '/painel/materiais-de-estudo/$id'
    | '/painel/minhas-provas/$id'
    | '/painel/materiais-de-estudo'
    | '/painel/minhas-provas'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/bem-vindo'
    | '/_app/painel'
    | '/_app/simulador-sisu'
    | '/avaliacao/$id'
    | '/onboarding/apelido'
    | '/onboarding/avatar'
    | '/onboarding/humor'
    | '/onboarding/tema'
    | '/provas/$id'
    | '/_app/painel/configuracoes'
    | '/_app/painel/listas-de-exercicio'
    | '/_app/painel/materiais-de-estudo'
    | '/_app/painel/minhas-provas'
    | '/_app/painel/simulador-sisu'
    | '/_app/painel/'
    | '/_app/painel/materiais-de-estudo/$id'
    | '/_app/painel/minhas-provas/$id'
    | '/_app/painel/materiais-de-estudo/'
    | '/_app/painel/minhas-provas/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  BemVindoRoute: typeof BemVindoRoute
  AvaliacaoIdRoute: typeof AvaliacaoIdRoute
  OnboardingApelidoRoute: typeof OnboardingApelidoRoute
  OnboardingAvatarRoute: typeof OnboardingAvatarRoute
  OnboardingHumorRoute: typeof OnboardingHumorRoute
  OnboardingTemaRoute: typeof OnboardingTemaRoute
  ProvasIdRoute: typeof ProvasIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/bem-vindo': {
      id: '/bem-vindo'
      path: '/bem-vindo'
      fullPath: '/bem-vindo'
      preLoaderRoute: typeof BemVindoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/provas/$id': {
      id: '/provas/$id'
      path: '/provas/$id'
      fullPath: '/provas/$id'
      preLoaderRoute: typeof ProvasIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/tema': {
      id: '/onboarding/tema'
      path: '/onboarding/tema'
      fullPath: '/onboarding/tema'
      preLoaderRoute: typeof OnboardingTemaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/humor': {
      id: '/onboarding/humor'
      path: '/onboarding/humor'
      fullPath: '/onboarding/humor'
      preLoaderRoute: typeof OnboardingHumorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/avatar': {
      id: '/onboarding/avatar'
      path: '/onboarding/avatar'
      fullPath: '/onboarding/avatar'
      preLoaderRoute: typeof OnboardingAvatarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/apelido': {
      id: '/onboarding/apelido'
      path: '/onboarding/apelido'
      fullPath: '/onboarding/apelido'
      preLoaderRoute: typeof OnboardingApelidoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/avaliacao/$id': {
      id: '/avaliacao/$id'
      path: '/avaliacao/$id'
      fullPath: '/avaliacao/$id'
      preLoaderRoute: typeof AvaliacaoIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/simulador-sisu': {
      id: '/_app/simulador-sisu'
      path: '/simulador-sisu'
      fullPath: '/simulador-sisu'
      preLoaderRoute: typeof AppSimuladorSisuRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/painel': {
      id: '/_app/painel'
      path: '/painel'
      fullPath: '/painel'
      preLoaderRoute: typeof AppPainelRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/painel/': {
      id: '/_app/painel/'
      path: '/'
      fullPath: '/painel/'
      preLoaderRoute: typeof AppPainelIndexRouteImport
      parentRoute: typeof AppPainelRoute
    }
    '/_app/painel/simulador-sisu': {
      id: '/_app/painel/simulador-sisu'
      path: '/simulador-sisu'
      fullPath: '/painel/simulador-sisu'
      preLoaderRoute: typeof AppPainelSimuladorSisuRouteImport
      parentRoute: typeof AppPainelRoute
    }
    '/_app/painel/minhas-provas': {
      id: '/_app/painel/minhas-provas'
      path: '/minhas-provas'
      fullPath: '/painel/minhas-provas'
      preLoaderRoute: typeof AppPainelMinhasProvasRouteImport
      parentRoute: typeof AppPainelRoute
    }
    '/_app/painel/materiais-de-estudo': {
      id: '/_app/painel/materiais-de-estudo'
      path: '/materiais-de-estudo'
      fullPath: '/painel/materiais-de-estudo'
      preLoaderRoute: typeof AppPainelMateriaisDeEstudoRouteImport
      parentRoute: typeof AppPainelRoute
    }
    '/_app/painel/listas-de-exercicio': {
      id: '/_app/painel/listas-de-exercicio'
      path: '/listas-de-exercicio'
      fullPath: '/painel/listas-de-exercicio'
      preLoaderRoute: typeof AppPainelListasDeExercicioRouteImport
      parentRoute: typeof AppPainelRoute
    }
    '/_app/painel/configuracoes': {
      id: '/_app/painel/configuracoes'
      path: '/configuracoes'
      fullPath: '/painel/configuracoes'
      preLoaderRoute: typeof AppPainelConfiguracoesRouteImport
      parentRoute: typeof AppPainelRoute
    }
    '/_app/painel/minhas-provas/': {
      id: '/_app/painel/minhas-provas/'
      path: '/'
      fullPath: '/painel/minhas-provas/'
      preLoaderRoute: typeof AppPainelMinhasProvasIndexRouteImport
      parentRoute: typeof AppPainelMinhasProvasRoute
    }
    '/_app/painel/materiais-de-estudo/': {
      id: '/_app/painel/materiais-de-estudo/'
      path: '/'
      fullPath: '/painel/materiais-de-estudo/'
      preLoaderRoute: typeof AppPainelMateriaisDeEstudoIndexRouteImport
      parentRoute: typeof AppPainelMateriaisDeEstudoRoute
    }
    '/_app/painel/minhas-provas/$id': {
      id: '/_app/painel/minhas-provas/$id'
      path: '/$id'
      fullPath: '/painel/minhas-provas/$id'
      preLoaderRoute: typeof AppPainelMinhasProvasIdRouteImport
      parentRoute: typeof AppPainelMinhasProvasRoute
    }
    '/_app/painel/materiais-de-estudo/$id': {
      id: '/_app/painel/materiais-de-estudo/$id'
      path: '/$id'
      fullPath: '/painel/materiais-de-estudo/$id'
      preLoaderRoute: typeof AppPainelMateriaisDeEstudoIdRouteImport
      parentRoute: typeof AppPainelMateriaisDeEstudoRoute
    }
  }
}

interface AppPainelMateriaisDeEstudoRouteChildren {
  AppPainelMateriaisDeEstudoIdRoute: typeof AppPainelMateriaisDeEstudoIdRoute
  AppPainelMateriaisDeEstudoIndexRoute: typeof AppPainelMateriaisDeEstudoIndexRoute
}

const AppPainelMateriaisDeEstudoRouteChildren: AppPainelMateriaisDeEstudoRouteChildren =
  {
    AppPainelMateriaisDeEstudoIdRoute: AppPainelMateriaisDeEstudoIdRoute,
    AppPainelMateriaisDeEstudoIndexRoute: AppPainelMateriaisDeEstudoIndexRoute,
  }

const AppPainelMateriaisDeEstudoRouteWithChildren =
  AppPainelMateriaisDeEstudoRoute._addFileChildren(
    AppPainelMateriaisDeEstudoRouteChildren,
  )

interface AppPainelMinhasProvasRouteChildren {
  AppPainelMinhasProvasIdRoute: typeof AppPainelMinhasProvasIdRoute
  AppPainelMinhasProvasIndexRoute: typeof AppPainelMinhasProvasIndexRoute
}

const AppPainelMinhasProvasRouteChildren: AppPainelMinhasProvasRouteChildren = {
  AppPainelMinhasProvasIdRoute: AppPainelMinhasProvasIdRoute,
  AppPainelMinhasProvasIndexRoute: AppPainelMinhasProvasIndexRoute,
}

const AppPainelMinhasProvasRouteWithChildren =
  AppPainelMinhasProvasRoute._addFileChildren(
    AppPainelMinhasProvasRouteChildren,
  )

interface AppPainelRouteChildren {
  AppPainelConfiguracoesRoute: typeof AppPainelConfiguracoesRoute
  AppPainelListasDeExercicioRoute: typeof AppPainelListasDeExercicioRoute
  AppPainelMateriaisDeEstudoRoute: typeof AppPainelMateriaisDeEstudoRouteWithChildren
  AppPainelMinhasProvasRoute: typeof AppPainelMinhasProvasRouteWithChildren
  AppPainelSimuladorSisuRoute: typeof AppPainelSimuladorSisuRoute
  AppPainelIndexRoute: typeof AppPainelIndexRoute
}

const AppPainelRouteChildren: AppPainelRouteChildren = {
  AppPainelConfiguracoesRoute: AppPainelConfiguracoesRoute,
  AppPainelListasDeExercicioRoute: AppPainelListasDeExercicioRoute,
  AppPainelMateriaisDeEstudoRoute: AppPainelMateriaisDeEstudoRouteWithChildren,
  AppPainelMinhasProvasRoute: AppPainelMinhasProvasRouteWithChildren,
  AppPainelSimuladorSisuRoute: AppPainelSimuladorSisuRoute,
  AppPainelIndexRoute: AppPainelIndexRoute,
}

const AppPainelRouteWithChildren = AppPainelRoute._addFileChildren(
  AppPainelRouteChildren,
)

interface AppRouteChildren {
  AppPainelRoute: typeof AppPainelRouteWithChildren
  AppSimuladorSisuRoute: typeof AppSimuladorSisuRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppPainelRoute: AppPainelRouteWithChildren,
  AppSimuladorSisuRoute: AppSimuladorSisuRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  BemVindoRoute: BemVindoRoute,
  AvaliacaoIdRoute: AvaliacaoIdRoute,
  OnboardingApelidoRoute: OnboardingApelidoRoute,
  OnboardingAvatarRoute: OnboardingAvatarRoute,
  OnboardingHumorRoute: OnboardingHumorRoute,
  OnboardingTemaRoute: OnboardingTemaRoute,
  ProvasIdRoute: ProvasIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
